// icon
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faCalculator } from '@fortawesome/free-solid-svg-icons/faCalculator'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt'
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faBezierCurve } from '@fortawesome/free-solid-svg-icons/faBezierCurve'
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase'
import { faQrcode } from '@fortawesome/free-solid-svg-icons/faQrcode'

// GUI Control
import GUICheckboxControl from '@/components/DataGrid/FormBuilder/gui/ui/controls/CheckboxControl'
import GUIDatePickerControl from '@/components/DataGrid/FormBuilder/gui/ui/controls/DatePickerControl'
import GUINumberControl from '@/components/DataGrid/FormBuilder/gui/ui/controls/NumberControl'
import GUISelectControl from '@/components/DataGrid/FormBuilder/gui/ui/controls/SelectControl'
import GUITextControl from '@/components/DataGrid/FormBuilder/gui/ui/controls/TextControl'
import GUITimePickerControl from '@/components/DataGrid/FormBuilder/gui/ui/controls/TimePickerControl'
import GUIWokrflowControl from '@/components/DataGrid/FormBuilder/gui/ui/controls/WorkflowControl'
import GUIQRScanControl from '@/components/DataGrid/FormBuilder/gui/ui/controls/QRScanControl'

// TEMPLATE Control
import TEMPLATETextControl from '@/components/DataGrid/FormBuilder/template/ui/common/controls/TextControl'
import TEMPLATENumberControl from '@/components/DataGrid/FormBuilder/template/ui/common/controls/NumberControl'
import TEMPLATECheckboxControl from '@/components/DataGrid/FormBuilder/template/ui/common/controls/CheckboxControl'
import TEMPLATEDatePickerControl from '@/components/DataGrid/FormBuilder/template/ui/common/controls/DatePickerControl'
import TEMPLATETimePickerControl from '@/components/DataGrid/FormBuilder/template/ui/common/controls/TimePickerControl'
import TEMPLATESelectControl from '@/components/DataGrid/FormBuilder/template/ui/common/controls/SelectControl'
import TEMPLATEWorkflowControl from '@/components/DataGrid/FormBuilder/template/ui/common/controls/WorkflowControl'
import TEMPLATEQRScanControl from '@/components/DataGrid/FormBuilder/template/ui/common/controls/QRScanControl'

// CONFIG CONTROL
import SIDEBARDatePickerControl from '@/components/DataGrid/FormBuilder/template/ui/sidebar_items/DatePickerConfigComponent'
import SIDEBARTimePickerControl from '@/components/DataGrid/FormBuilder/template/ui/sidebar_items/TimePickerConfigComponent'
import SIDEBARSelectControl from '@/components/DataGrid/FormBuilder/template/ui/sidebar_items/SelectConfigComponent'
import SIDEBARNumberControl from '@/components/DataGrid/FormBuilder/template/ui/sidebar_items/NumberConfigComponent'
import SIDEBARTextControl from '@/components/DataGrid/FormBuilder/template/ui/sidebar_items/TextConfigComponent'
import SIDEBARCheckboxControl from '@/components/DataGrid/FormBuilder/template/ui/sidebar_items/CheckboxConfigComponent'
import SIDEBARWorkflowControl from '@/components/DataGrid/FormBuilder/template/ui/sidebar_items/WorkflowConfigComponent'
import SIDEBARQRScanControl from '@/components/DataGrid/FormBuilder/template/ui/sidebar_items/QRScanConfigComponent'

// Template Control
// special key for control:
// other_properties: {
//     x: "zzz",
//     c: "xxx",
//     ...
// },
// validation_func: function() {
//  // validation function here
// }
//
const CONTROL_TYPES = {
  text: {
    label: 'Text Input',
    icon: faEdit,
    source: {
      gui: GUITextControl,
      template: TEMPLATETextControl,
      config: SIDEBARTextControl,
    },
  },
  number: {
    label: 'Number Input',
    icon: faCalculator,
    source: {
      gui: GUINumberControl,
      template: TEMPLATENumberControl,
      config: SIDEBARNumberControl,
    },
  },
  datepicker: {
    label: 'Date Picker',
    icon: faCalendarAlt,
    source: {
      gui: GUIDatePickerControl,
      template: TEMPLATEDatePickerControl,
      config: SIDEBARDatePickerControl,
    },
  },
  // timepicker: {
  //     label:"Time Picker",
  //     icon: faClock,
  //     source: {
  //         gui: GUITimePickerControl,
  //         template: TEMPLATETimePickerControl,
  //         config: SIDEBARTimePickerControl,
  //     }
  // },
  select: {
    label: 'Select Option',
    icon: faDatabase,
    source: {
      gui: GUISelectControl,
      template: TEMPLATESelectControl,
      config: SIDEBARSelectControl,
    },
  },
  checkbox: {
    label: 'Checkbox',
    icon: faCheck,
    source: {
      gui: GUICheckboxControl,
      template: TEMPLATECheckboxControl,
      config: SIDEBARCheckboxControl,
    },
  },
  workflow: {
    label: 'Workflow',
    icon: faBezierCurve,
    source: {
      gui: GUIWokrflowControl,
      template: TEMPLATEWorkflowControl,
      config: SIDEBARWorkflowControl,
    },
  },
  qrScan: {
    label: 'QR Scan',
    icon: faQrcode,
    source: {
      gui: GUIQRScanControl,
      template: TEMPLATEQRScanControl,
      config: SIDEBARQRScanControl,
    },
  },
}

export { CONTROL_TYPES }
